<template>
    <div class="flex flex-col items-center sm:justify-center sm:pt-0" :class="{ 'min-h-screen': standalone }">
        <div class="px-5 sm:w-1/5">
            <slot name="logo" />
        </div>

        <div class="flex flex-col pb-6 pt-4 px-6 w-full overflow-hidden space-y-4 sm:max-w-lg sm:rounded-lg">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        standalone: {
            default: true,
            type: Boolean,
        },
    },
}
</script>
